import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import axios, { AxiosError } from "axios";
import { getUser } from "./helpers";

export const authAxios = axios.create();

authAxios.interceptors.request.use((config) => {
  const user = getUser();

  if (config.headers && user?.access_token) {
    config.headers.Authorization = `${user?.token_type} ${user?.access_token}`;
  }

  return config;
});

export function useAxiosTokenRefresh() {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated) {
      const authHeader = `${auth.user?.token_type} ${auth.user?.access_token}`;

      authAxios.interceptors.response.use(
        (response) => response,
        async (error) => {
          const originalRequest = error.config;

          if (error?.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            await auth.signinSilent();

            originalRequest.headers.Authorization = authHeader;

            return axios(originalRequest);
          }

          return Promise.reject(error as AxiosError);
        }
      );
    }
  }, [auth, authAxios]);
}
